import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../util/AuthUtils";
import useStore from "../hooks/useStore";
import useLocalStorage from "../hooks/useLocalStorage";
import Commons from "../util/commons";

export default function RefreshAndNewSale() {
    const navigate = useNavigate();
    const setLoggedInUser = useStore((state) => state.setLoggedInUser);
    const setSelectedCompany = useStore((state) => state.setSelectedCompany);
    const [company, saveCompany, removeCompany] = useLocalStorage("company", null);
    const [, saveUser, removeUser] = useLocalStorage("user", null);

    useEffect(() => {
        getCurrentUser()
            .then(response => {
                if (response == undefined) {
                    removeUser();
                } else {
                    saveUser(response.user);
                    setLoggedInUser(response.user);
                    if (response.companies && response.companies.length > 0) {
                        if (response.companies.length === 1) {
                            saveCompany(response.companies[0]);
                            setSelectedCompany(response.companies[0]);
                        } else if (company) {
                            const ids = response.companies.map(c => c.id);
                            if (ids.includes(company.id)) {
                                const _company = response.companies.find(c => c.id === company.id);
                                saveCompany(_company);
                                setSelectedCompany(_company);
                            } else {
                                removeCompany();
                                Commons.setDefault("branch", undefined);
                                Commons.setDefault("invoiceType", undefined);
                                Commons.setDefault("series", undefined);
                            }
                        }
                    }
                }
            })
            .catch(() => removeUser())
            .finally(() => navigate("/sale", { replace: true }));
    }, []);

    return null;
}
